// src/providers/counter-store-provider.tsx
"use client";

import { type ReactNode, createContext, useRef, useContext } from "react";
import { useStore } from "zustand";
import { BreadcrumbsStore, createBreadcrumbsStore } from "@/stores/breadcrumbStore";
export type BreadcrumbsStoreApi = ReturnType<typeof createBreadcrumbsStore>;
export const BreadcrumbsStoreContext = createContext<BreadcrumbsStoreApi | undefined>(undefined);
export interface BreadcrumbsStoreProviderProps {
  children: ReactNode;
}
export const BreadcrumbsStoreProvider = ({
  children
}: BreadcrumbsStoreProviderProps) => {
  const storeRef = useRef<BreadcrumbsStoreApi>();
  if (!storeRef.current) {
    storeRef.current = createBreadcrumbsStore();
  }
  return <BreadcrumbsStoreContext.Provider value={storeRef.current} data-sentry-element="unknown" data-sentry-component="BreadcrumbsStoreProvider" data-sentry-source-file="BreadcrumbsStoreProvider.tsx">
      {children}
    </BreadcrumbsStoreContext.Provider>;
};
export const useBreadcrumbsStore = <T,>(selector: (store: BreadcrumbsStore) => T): T => {
  const breadcrumbsStoreContext = useContext(BreadcrumbsStoreContext);
  if (!breadcrumbsStoreContext) {
    throw new Error(`useBreadcrumbsStore must be used within breadcrumbsStoreProvider`);
  }
  return useStore(breadcrumbsStoreContext, selector);
};